module.exports = __webpack_public_path__ + "media/images/flags/64/Japan-2153ee2eebe1869deec0bf3099efb49c.png";